const ga = require('ga');

export default function sendEventToGoogleAnalytics(category, action, label) {
	if (typeof ga !== 'undefined') {
		ga('send', 'event', category, action, label);
	}
}



/** WEBPACK FOOTER **
 ** ./Scripts/libs/utils/googleAnalytics.js
 **/